import { createSlice } from "@reduxjs/toolkit";

const incidentsSlice = createSlice({
  name: "incidents",
  initialState: [],
  reducers: {
    setIncidents: (state, action) => action.payload,
    addIncident: (state, action) => {
      state.push(action.payload);
    },
  },
});

export const { setIncidents, addIncident } = incidentsSlice.actions;
export default incidentsSlice.reducer;
